import { gql } from '@apollo/client';

export const BULK_UPDATE_SEQUENCES_V5 = gql`
  mutation bulkUpdateSequencesV5($inputs: [SequenceInput!]!) {
    bulkUpdateSequencesV5: bulkUpdateSequencesV5(inputs: $inputs) {
      adSequence {
        order
        adId
        name
        sequenceId
        updatedAt
        podPosition
        podAlignment
      }
      id
      name
      type
    }
  }
`;
